import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-cream text-maroon/70 py-12 border-t border-maroon/10" data-id="element-53">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center" data-id="element-54">
        <div className="mb-6 md:mb-0 text-center md:text-left" data-id="element-55">
          <h3 className="font-serif text-2xl text-maroon mb-2" data-id="element-56">
            Lead
            <em className="font-light italic text-transparent bg-clip-text bg-gradient-to-r from-blush to-berry-light" data-id="element-57">
              Her
            </em>
            Ship Equity
          </h3>
          <p className="text-sm text-navy/60" data-id="element-58">
            Where women move from side hustles to scalable LeadHerShip.
          </p>
        </div>

        <div className="text-sm text-center md:text-right text-navy/50" data-id="element-59">
          <p data-id="element-60">&copy; {currentYear} LeadHerShip Equity. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}